export function buildingTintForPlayerIndex(index: number): number {
    if (index === -1) {
        return 0x000000;
    }
    const tints = [0xffffff, 0x00ffff, 0xffff00, 0x88ff88, 0x8888ff, 0xff8888, 0xff00ff];
    return tints[index];
}

export function markerTintForPlayerIndex(index: number): number {
    let tint = buildingTintForPlayerIndex(index);
    if (tint === 0xffffff) tint = (229 << 16) + (167 << 8) + 189;
    const factor = 2 / 3;
    const r = Math.floor(((tint & 0xff0000) >> 16) * factor);
    const g = Math.floor(((tint & 0x00ff00) >> 8) * factor);
    const b = Math.floor((tint & 0x0000ff) * factor);
    return (r << 16) + (g << 8) + b;
}



// WEBPACK FOOTER //
// ./src/Pixi/player-colors.ts